import axios from './axios';

export const getSubcontractors = ({ params } = {}) => axios.get(`subcontractors`, { params });
export const getSubcontractor = ({id, params }) => axios.get(`subcontractors/${id}`, { params });
export const createSubcontractor = ({ data }) => axios.post('subcontractors', data);
export const updateSubcontractor = ({ id, data }) => axios.put(`subcontractors/${id}`, data);
export const deleteSubcontractor = ({ id }) => axios.delete(`subcontractors/${id}`);